import React from 'react';
import { motion } from 'framer-motion';
export function ProductRevealSection() {
  return <section className="py-20 px-4" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-104">
          <p className="text-lg sm:text-xl text-[#2D1B06]/80 leading-relaxed mb-8" data-id="element-105">
            He condensado años de ciencia nutricional en un sistema simple de{' '}
            <strong className="text-[#E8820C]" data-id="element-106">20 páginas</strong>. Sin términos
            médicos complicados, sin ingredientes caros de "tiendas orgánicas".
            Solo comida real de tu supermercado local y una estrategia basada en{' '}
            <strong className="text-[#E8820C]" data-id="element-107">horarios metabólicos</strong>.
          </p>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#2D1B06] uppercase tracking-tight" data-id="element-108">
            Presentamos: <br data-id="element-109" />
            <span className="text-[#E8820C] inline-block mt-2" data-id="element-110">
              El Protocolo de Reseteo Metabólico 21D
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative mx-auto max-w-4xl" data-id="element-111">
          {/* Decorative background glow */}
          <div className="absolute inset-0 bg-[#E8820C]/20 blur-3xl rounded-full transform scale-90 -z-10" data-id="element-112" />

          <img src="https://cdn.magicpatterns.com/uploads/qCXDksfosKWBkfXtg6sJiV/Cover_El_Protocolo_21D.png" alt="El Protocolo 21D - Guía Principal en libro, tablet y móvil" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-113" />
        </motion.div>
      </div>
    </section>;
}